import { render, staticRenderFns } from "./TvaInput.vue?vue&type=template&id=5a480bc6"
import script from "./TvaInput.vue?vue&type=script&lang=js"
export * from "./TvaInput.vue?vue&type=script&lang=js"
import style0 from "./TvaInput.vue?vue&type=style&index=0&id=5a480bc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports